import './facets.scss';

import Link, { LinkVariant } from '../link/Link';
import Tag, { TagProps } from '../tag/Tag';

import { IAccessoryFilter } from '../../lib/system-selector/interfaces';
import ScrollableContainer from '../scrollable-container/ScrollableContainer';

interface FacetsProps {
  amount: number;
  searchTerm?: string;
  clearButtonLabel?: string;
  facets: IAccessoryFilter[];
  isLoading?: boolean;
  onRemoveFacet: (facet: TagProps) => void;
  onClear: () => void;
}

const Facets = ({
  amount,
  searchTerm,
  clearButtonLabel = 'Clear all',
  facets,
  isLoading = false,
  onRemoveFacet,
  onClear,
}: FacetsProps) => {
  return (
    <div className="m-facets">
      <div className="u-white-space-nowrap u-text-small">
        {amount} results {facets.length > 0 ? 'for:' : ''} {searchTerm && `'${searchTerm}'`}
      </div>
      {/* <pre>{JSON.stringify(facets, null, 4)}</pre> */}
      {facets && facets.length > 0 && (
        <ScrollableContainer>
          <div className="a-tag-group">
            {facets.map((facet: IAccessoryFilter, index) => (
              <Tag
                id={facet.id}
                key={index}
                label={facet.label}
                isFacet
                isLoading={isLoading}
                onClick={() => onRemoveFacet(facet)}
                filterType={facet.filterType}
                includedInTopFilter={facet.includedInTopFilter}
              />
            ))}
            {clearButtonLabel && facets.length > 1 && (
              <Link
                label={clearButtonLabel}
                variant={LinkVariant.BUTTON}
                isSmall
                onClick={onClear}
              />
            )}
          </div>
        </ScrollableContainer>
      )}
    </div>
  );
};

export default Facets;
